import { createStore, withProps } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';

import { ChangeStatusData } from '~shared/types/websockets.types';

export const effectsStore = createStore(
	{ name: 'effects' },
	withEntities<ChangeStatusData, 'correlationId'>({ idKey: 'correlationId' }),
	withProps<{ loaded: boolean }>({ loaded: false })
);
